<template>

    <footer class="footer-bg footer-p pd-100 pb-0">

        <div class="footer-top pb-30">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-6">
                        <div class="footer-widget mb-30">
                            <div class="logo mb-35">
                                <router-link :to="{ name: 'HomePage'}">
                                <!--<img src="../../../../../assets/images/logo/logo-white.png" alt="logo" />-->
                                <img :src="companyLogo" :alt="companyName"  />
                                </router-link>
                            </div>
                            <div class="footer-text mb-4">
                                <p>
                                    {{FooterLogoDescription}}
                                </p>
                            </div>
                            <div class="footer-social mb-5">
                                <SocialMediaIconComponent></SocialMediaIconComponent>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-5 col-lg-4 col-md-3 col-sm-6">
                        <div class="footer-widget mb-30 pl-60">
                            <div class="f-widget-title">
                                <h5>{{$t('StoreFront.Links')}}</h5>
                            </div>
                            <div class="footer-link">
                                <ul>
                                    <li v-for="link in footerNavLinks">
                                        <router-link class="nav-link" v-if="link.routeUrl != 'Booking'" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                                        <router-link class="nav-link" v-if="link.routeUrl == 'Booking'" :to="{ name: 'Booking Detail', params: { Id: '76C48B75-6F88-48C6-BE61-A4F7E207916B' } }">{{link.displayText}}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                        <div class="footer-widget mb-30">
                            <div class="f-widget-title">
                                <h5>{{$t('StoreFront.ContactUs')}}</h5>
                            </div>
                            <div class="footer-link">
                                <div class="body contact-area">
                                    <!-- single address -->
                                    <div class="single-address">
                                        <div class="icon">
                                            <i class="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div class="discription">
                                            <p>{{$t('StoreFront.OurAddress')}}</p>
                                            <span>{{OurAddress}}</span>
                                        </div>
                                    </div>
                                    <!-- single address end -->
                                    <!-- single address -->
                                    <div class="single-address">
                                        <div class="icon">
                                            <i class="fas fa-envelope"></i>
                                        </div>
                                        <div class="discription">
                                            <p>{{$t('StoreFront.OurEmail')}}</p>
                                            <span>{{OurEmail}}</span>
                                        </div>
                                    </div>
                                    <!-- single address end -->
                                    <!-- single address -->
                                    <div class="single-address" v-if="OurPhone!='(___) ___-____' && $filters.IsNull(OurPhone,true,null)!=null">
                                        <div class="icon">
                                            <i class="fas fa-headset"></i>
                                        </div>
                                        <div class="discription">
                                            <p>{{$t('StoreFront.OurPhone')}}</p>
                                            <span>{{OurPhone}}</span>
                                        </div>
                                    </div>
                                    <!-- single address end -->
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="copyright-wrap">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="copyright-text text-center">
                            <p v-html="Copyrights"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>


</template>

<script>
    import SocialMediaIconComponent from '@/views/SocialMediaIcons/socialMediaIcons.vue'
    export default {
        name: 'FooterVue',
        props: ["footerNavLinks", "serviceLinks", "FooterLogoDescription", "OurAddress", "OurEmail", "OurPhone", "Copyrights","secondaryLogoLink"],
        components: {
            SocialMediaIconComponent
        },
        data() {
            return {
                companyLogo: '',
                companyName: ''
            }
        },
        created() {
            this.getCompanyLogo();
            this.companyName = localStorage.getItem('companyName')
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            }
        }

    }
</script>